<div class="modal-header">
    <h4 translate="common.qrcode"></h4>

    <button class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')">
    </button>
</div>

<div class="modal-body">
    <fieldset class="btn-group mb-4">
        <input class="btn-check" type="radio" name="access" id="public-access"
               (change)="selectAccess(QrCodeAccessType.Public)">
        <label class="btn btn-toggle btn-toggle-left h-auto" for="public-access"
               [ngClass]="{ active: this.selectedAccess === QrCodeAccessType.Public }">{{ 'services.manage.qrcode.public' | translate }}</label>

        <input class="btn-check" type="radio" name="access" id="private-access"
               (change)="selectAccess(QrCodeAccessType.Private)">
        <label class="btn btn-toggle btn-toggle-right h-auto" for="private-access"
               [ngClass]="{ active: this.selectedAccess === QrCodeAccessType.Private }">{{ 'services.manage.qrcode.private' | translate }}</label>
    </fieldset>

    <div class="text-center">
        <h5>{{ qrName }}</h5>
        <qrcode [qrdata]="qrData" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        <div class="text-break">{{ qrData }}</div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary"
            (click)="activeModal.close()" translate="common.close">
    </button>
</div>

